const ON_CHANGE_DEBOUNCE_TIMER = 300;

/**
 * Localized option labels used by JS (tone picker, PDP swatches, product info).
 *
 * KEEP IN SYNC WITH: snippets/option-label-matches.liquid
 * When adding a new locale/site, add the translated option labels (all, shade,
 * size, color) in BOTH this file and option-label-matches.liquid.
 */
const HB_LOCALIZED_LABELS = {
  all: ["All", "Tout", "Tutto", "Tutti", "Todo", "Todos", "Alle", "الكل"],
  shade: ["Shade", "Teinte", "Tonalità", "Tonalita", "Tono", "Farbton", "Color", "Couleur", "Colore", "Farbe", "الدرجة اللونية", "الدرجة", "اللون"],
  size: ["Size", "Taille", "Dimensione", "Tamaño", "Tamano", "Größe", "Grosse", "Groesse", "المقاس", "الحجم"],
  color: ["Color", "Couleur", "Colore", "Farbe", "اللون"],
};

const HB_normalizeLabel = (value) => (value || "").toLowerCase().trim();

const HB_isAllLabel = (value) => {
  const normalized = HB_normalizeLabel(value);
  if (!normalized) return false;

  const themeAllLabel = window.HB_THEME_LABELS?.all;
  if (themeAllLabel && HB_normalizeLabel(themeAllLabel) === normalized) {
    return true;
  }

  return HB_LOCALIZED_LABELS.all.some((label) => HB_normalizeLabel(label) === normalized);
};

const HB_matchesOptionLabel = (optionName, type) => {
  const labels = HB_LOCALIZED_LABELS[type] || [];
  const normalized = HB_normalizeLabel(optionName);
  return labels.some((label) => HB_normalizeLabel(label) === normalized);
};

const HB_isShadeOptionLabel = (optionName) =>
  HB_matchesOptionLabel(optionName, "shade") || HB_matchesOptionLabel(optionName, "color");

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};
